// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iy1B","content":"styles_content__3dBJT"};